<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IMPORT_PLAN_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label
          >Выберите отраслевой перечень, куда включена Ваша продукция:</label
        >
      </p>
      <select
        v-model="$parent.project.UF_IMPORT_PLAN_ID"
        class="sel-dropdown i-main-style i-wid-50"
        v-on:change="clearUfCodeProducts"
        :disabled="
          $parent.$parent.projectDisabled ||
            $parent.project.UF_IMPORT_PLAN_ID_DISABLED == 1
        "
      >
        <option value></option>

        <template v-if="$parent.project.UF_IMPORT_PLAN_LIST.length > 0">
          <option
            v-for="item in filterImportPlanList"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
            v-show="in_array(item.ID, $parent.project.UF_IMPORT_PLAN_LIST)"
          ></option>
        </template>
        <template v-else>
          <option
            v-for="item in filterImportPlanList"
            v-bind:value="item.ID"
            v-bind:key="item.ID"
            v-text="item.NAME"
          ></option>
        </template>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IMPORT_PLAN_ID"
          )
        }}
      </div>
      <div v-if="$parent.project.UF_IMPORT_PLAN_ID > 0">
        <a target="_blank" :href="importPlanLink.URL">{{
          importPlanLink.NAME
        }}</a>
      </div>
    </div>
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_CODE_PRODUCTS'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Укажите шифр продукции:</label>
        <!-- {{importPlanLink.ID}}
        {{filterProductPlanImport}}-->
        <!-- {{$parent.directory.product_plan_import}} -->
      </p>
      <input
        v-if="$parent.project.UF_VERSION_SHIFR_PRD === 1"
        type="text"
        class="i-main-style i-wid-29"
        v-model="$parent.project.UF_CODE_PRODUCTS"
        @keyup="
          this.$parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_CODE_PRODUCTS'
          )
        "
        :disabled="$parent.$parent.projectDisabled"
      />
      <multiselect
        class="js-multiselect-bootom i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
        v-if="
          $parent.project.UF_VERSION_SHIFR_PRD === 2 ||
            $parent.project.UF_VERSION_SHIFR_PRD === 3
        "
        label="LABEL"
        :limit="200"
        :limitText="filterItemText"
        track-by="ID"
        v-model="$parent.project.UF_SHIFR_PRD_ID"
        :options="filterProductPlanImport"
        :multiple="true"
        placeholder
        :disabled="$parent.$parent.projectDisabled ? true : false"
      >
        <span slot="noOptions"
          >Выберите отраслевой перечень, куда включена Ваша продукция для
          обновления списка шифров продукции</span
        >
        <span slot="noResult">Продукция не найдена</span>
      </multiselect>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_SHIFR_PRD_ID")
        }}
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "import_plan",
  components: {
    Multiselect
  },
  computed: {
    importPlanLink() {
      if (this.$parent.project.UF_IMPORT_PLAN_ID > 0) {
        let t = this.$parent.directory.list_import_plan.filter(
          c => c.ID === this.$parent.project.UF_IMPORT_PLAN_ID
        );
        if (t.length > 0 && t[0].URL !== null) {
          return t[0];
        }
      }

      return {
        NAME: "",
        URL: ""
      };
    },
    filterImportPlanList() {
      let ret = [];
      let isViewCriticalList =
        this.$parent.project.UF_SETTING &&
        this.$parent.project.UF_SETTING.SHOW_IMPORT_PLAN_ID &&
        this.$parent.project.UF_SETTING.SHOW_IMPORT_PLAN_ID.length > 0
          ? true
          : false;

      this.$parent.directory.list_import_plan.forEach(function(item) {
        if (isViewCriticalList && item.IS_CRITICAL_PRODUCTS_LIST === 1) {
          if (
            this.in_array(
              item.ID,
              this.$parent.project.UF_SETTING.SHOW_IMPORT_PLAN_ID
            )
          ) {
            ret.push(item);
          }

        } else if (item.IS_CRITICAL_PRODUCTS_LIST !== 1) {
          if (
            this.$parent.project.UF_SETTING &&
            this.$parent.project.UF_SETTING.HIDE_IMPORT_PLAN_ID &&
            this.$parent.project.UF_SETTING.HIDE_IMPORT_PLAN_ID.length > 0
          ) {
            if (
              !this.in_array(
                item.ID,
                this.$parent.project.UF_SETTING.HIDE_IMPORT_PLAN_ID
              )
            ) {
              ret.push(item);
            }
          } else {
            ret.push(item);
          }
        }
      }, this);
      return ret;
    },

    filterProductPlanImport() {
      // if (this.importPlanLink > 0) {
      let versionShifrPrd = this.$parent.project.UF_VERSION_SHIFR_PRD;

      if (
        this.isObject(this.$parent.project.UF_SETTING.DOP_SETTING_SHIFR_PRD)
      ) {
        this.$parent.project.UF_SETTING.DOP_SETTING_SHIFR_PRD.forEach(function(
          it
        ) {
          if (it.UF_IMPORT_PLAN_ID == this.$parent.project.UF_IMPORT_PLAN_ID) {
            //this.importPlanLink.ID
            versionShifrPrd = it.UF_VERSION_SHIFR_PRD;
          }
        },
        this);
      }

      let t = this.$parent.directory.product_plan_import.filter(
        el =>
          el.IMPORT_PLAN_ID === this.$parent.project.UF_IMPORT_PLAN_ID &&
          el.VERSION === versionShifrPrd
      );
      if (t.length > 0) {
        return t;
      } else if (this.$parent.project.UF_SHIFR_PRD_ID.length > 0) {
        t = this.$parent.project.UF_SHIFR_PRD_ID;
        return t;
      }
      // }
      return [];
    }
  },
  methods: {
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    clearUfCodeProducts() {
      let u = this.$parent.project.UF_SHIFR_PRD_ID;
      u.splice(0, u.length);
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_IMPORT_PLAN_ID"
      );
    },
    isObject(val) {
      return typeof val === "object";
    },
    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    },
    filterPlanByCode(id) {
      let t = this.$parent.directory.list_import_plan.filter(
        el => el.ID === id
      );

      return t[0] ? t[0].CODE : "";
    }
  }
};
</script>

<style scoped></style>
